import React from 'react';
import PropTypes from 'prop-types';
import {
  CardActionable, CardContent, CardLayout, CardMedia,
} from '@americanexpress/dls-react';

const GridLayoutSansCatalog = ({ children }) => (
  <CardActionable
    orientation="vertical"
    className="pad-0 height-full"
    data-testid="view-all-tile"
  >
    <CardMedia className="no-scroll">
      {children[0]}
    </CardMedia>
    <CardLayout className="flex-item-grow">
      <CardContent className="flex-item-grow pad-0-t pad-2-b">
        <div className="height-full flex flex-justify-between flex-column pad-2-lr pad-0-tb">
          <div data-testid="body" id="body" className="pad-0">
            {children[1]}
            {children[2]}
          </div>
          <div className="pad-2-t flex flex-column flex-align-center flex-justify-between">
            {children[3]}
            <div className="pad-1-b" />
            {children[4]}
            <div className="pad-1-b" />
            {children[5]}
          </div>
        </div>
      </CardContent>
    </CardLayout>
  </CardActionable>
);

GridLayoutSansCatalog.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
};

export default GridLayoutSansCatalog;
